import React from 'react';

const WeatherPage: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-h2 text-ui-text">Weather</h1>
    </div>
  );
};

export default WeatherPage;
